import { z } from 'zod';
import { Filters_Snapshot_S } from '~/core/features/filtering/types/filters.schema';
import { IndexFilters_Snapshot_S } from '~/core/features/indexFiltering/types/indices.schema';
import { SelectedSort_S } from '~/core/features/sorting/types/sorting.schema';

export const SnapshotSet_S = z.object({
    querySetIdentifier: z.string(),
    indices: IndexFilters_Snapshot_S.optional(),
    filters: Filters_Snapshot_S.optional(),
    sorting: SelectedSort_S.optional(),
    /*     size: z.number().optional(),
    pagination: z.object({ size: z.number() }), */
});

export const SnapshotSets_S = z.array(SnapshotSet_S);

export type SnapshotSet = z.infer<typeof SnapshotSet_S>;
export type SnapshotSets = z.infer<typeof SnapshotSets_S>;
